<div class="dayButton" [ngClass]="{selected: isSelected, first: isFirst, last: isLast}" (mouseenter)="onOver($event)" (mouseleave)="onOut($event)" #btn>
    <div class="month">{{month}}</div>
    <div class="date">{{dateNumber}}</div>
    <div class="day">{{day}}</div>
</div>